module.exports = __webpack_public_path__ + "static/img/check.e6ef3b45.svg";